/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
//Used in ui-activitypass, ui-internal-activitypass, ui-internal-marketing, ui-internal-parkpass, ui-internal-pass, ui-internal-passes-management, ui-internal-pos, ui-internal-qr-code, ui-internal-scanner, ui-internal-special-access-pass, ui-tree-permit, ui-internal-tree-permit, ui-venue, ui-internal-venue, ui-sitepass
import axios from 'axios';

export const defaultOptions = { headers: {} };

/**
 * @typedef {Object} SecurityUtils
 * @property {Function} getAuthHeader Gets internal or external R1S authorization headers
 */

/**
 * Returns Axios headers merged with authentication properties from the provided securityHelper
 * @param {SecurityUtils} securityHelper A helper which returns internal or external authorization headers
 * @param {Object} addlHeaders={} Additional Axios headers
 * @return {{Authorization: *}}
 */
export function authHeaders(securityHelper, addlHeaders = {}) {
    return { ...addlHeaders, Authorization: securityHelper.getAuthHeader() };
}

/**
 * Generate API helper methods incorporating authentication headers from the provided securityHelper
 * @param {SecurityUtils} securityHelper A helper with a getAuthHeader() function
 * @return {*} API helper functions wrapping Axios HTTP methods (get, post, put, delete as remove)
 */
export const apiHelpers = (securityHelper) => {
    const get = (url, options = defaultOptions) => axios.get(url, options);
    const post = (url, data, options = defaultOptions) => axios.post(url, data, options);
    const put = (url, data, options = defaultOptions) => axios.put(url, data, options);
    const remove = (url, options = defaultOptions) => axios.delete(url, options);

    return {
        get,
        post,
        put,
        remove,
        getWithAuth(url, options = defaultOptions) {
            return get(url, {
                ...options,
                headers: authHeaders(securityHelper, options.headers),
            });
        },
        postWithAuth(url, data, options = defaultOptions) {
            return post(url, data, {
                ...options,
                headers: authHeaders(securityHelper, options.headers),
            });
        },
        putWithAuth(url, data, options = defaultOptions) {
            return put(url, data, {
                ...options,
                headers: authHeaders(securityHelper, options.headers),
            });
        },
        removeWithAuth(url, options = defaultOptions) {
            return remove(url, {
                ...options,
                headers: authHeaders(securityHelper, options.headers),
            });
        },
    };
};
